import actions from '@/requests/workspaces/constants';
import withDraft from '@/utils/draftHelper';
import { showWorkspaceFormState } from './state';
import { workspaceForms } from '../constants';

const showWorkspaceForm = withDraft((draft, action) => (
  showWorkspaceFormState(draft, { ...action, category: 'open', code: workspaceForms.REQUEST })
));

export default {
  [actions.SHOW_FORM_FOR_WORKSPACE_REQUEST]: showWorkspaceForm,
  [actions.SHOW_WORKSPACE_FORM_FOR_REQUEST]: showWorkspaceForm,
};
